import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "entry", "batch", "dateSeparator", "fieldRow"]

  filter() {
    const selectedField = this.selectTarget.value

    // Filter entries
    this.entryTargets.forEach(entry => {
      const fields = entry.dataset.auditedFields?.split(',') || []
      const matches = !selectedField || fields.includes(selectedField)
      entry.style.display = matches ? '' : 'none'
    })

    // Hide batches when filtering (they don't have specific fields)
    this.batchTargets.forEach(batch => {
      batch.style.display = selectedField ? 'none' : ''
    })

    // Highlight matching field rows
    this.highlightFieldRows(selectedField)

    // Hide date separators with no visible entries
    this.updateDateSeparators()
  }

  highlightFieldRows(selectedField) {
    this.fieldRowTargets.forEach(row => {
      const field = row.dataset.field
      if (selectedField && field === selectedField) {
        row.classList.add('audit-history__field-row--highlighted')
      } else {
        row.classList.remove('audit-history__field-row--highlighted')
      }
    })
  }

  updateDateSeparators() {
    this.dateSeparatorTargets.forEach(separator => {
      // Find next sibling entries until next separator
      let hasVisibleEntry = false
      let sibling = separator.nextElementSibling

      while (sibling && !sibling.classList.contains('audit-history__date-separator')) {
        if (sibling.style.display !== 'none') {
          hasVisibleEntry = true
          break
        }
        sibling = sibling.nextElementSibling
      }

      separator.style.display = hasVisibleEntry ? '' : 'none'
    })
  }
}
